module.exports = __webpack_public_path__ + "static/img/14000313.f21b9ae3.png";